module.exports = __webpack_public_path__ + "img/ig.e815c8c6.svg";